import * as React from 'react';

/**
 * A bit of a hack to prevent scrolling when the `open` prop is set to true.
 *
 * This is semi-OK as the body element is outside the scope of React.
 *
 * @param props
 */
export const usePreventBodyScroll = (open: boolean) => {
  React.useEffect(() => {
    if (open) {
      document.body.classList.add('overflow-hidden');
    } else {
      document.body.classList.remove('overflow-hidden');
    }

    return () => document.body.classList.remove('overflow-hidden');
  }, [open]);
};
